import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { notification, Modal, Button, Descriptions, Input, Form } from 'antd';
import "./MyInfoModal.scss";

@inject('commonStore')
@observer
class MyInfoModal extends Component {
  onModpw = (values) => {
    if (values.cePwNew !== values.cePwNew1) {
      notification.warning({placement: 'bottomLeft', message: `변경 비밀번호가 같지 않습니다..`, duration: 2});
      return false;
    } else {
      this.props.commonStore.modPwInfo(values.cePw, values.cePwNew);
    }
  };

  render() {
    const { modalOpen, sessionLoginInfo } = this.props;
    const ModalForm: React.FC<ModalFormProps> = ({ visible }) => {
      const [form] = Form.useForm();
    
      const onCancel = () => {
        form.resetFields();
        this.props.modalClose();
      };
    
      return (
        <Modal 
          width={600}
          title="마이페이지(비밀번호 변경)"
          closable={false}
          visible={visible}
          onCancel={onCancel}
          footer={null}
        >
          <div className="table_th_W">
            <Descriptions bordered>
              <Descriptions.Item label="아이디 *" span={3}>
              {(sessionLoginInfo !== null && sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null 
                && (sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG  && sessionLoginInfo.ceType !== process.env.REACT_APP_TYPE_YUJIN) ) 
                && <Fragment>svc</Fragment>}
              {sessionLoginInfo.ceCd !== undefined && sessionLoginInfo.ceCd !== null && sessionLoginInfo.ceCd}
              </Descriptions.Item>
              {(sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null) &&
                (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_CENTER)
              ? <Fragment>
                  <Descriptions.Item label="지사 *" span={3}>
                    {sessionLoginInfo.ceBranchNm !== undefined && sessionLoginInfo.ceBranchNm !== null && sessionLoginInfo.ceBranchNm}
                    {/*  (ceBranchCd) 삭제 코드               
                    {sessionLoginInfo.ceBranchCd !== undefined && sessionLoginInfo.ceBranchCd !== null && sessionLoginInfo.ceBranchCd !== '' &&
                      <Fragment>( {sessionLoginInfo.ceBranchCd} )</Fragment>} */}
                  </Descriptions.Item>
                  <Descriptions.Item label="센터 *" span={3}>
                    {sessionLoginInfo.ceNm !== undefined && sessionLoginInfo.ceNm !== null && sessionLoginInfo.ceNm}
                  </Descriptions.Item>
                </Fragment>
              : <Descriptions.Item label="지사 *" span={3}>
                  {sessionLoginInfo.ceNm !== undefined && sessionLoginInfo.ceNm !== null && sessionLoginInfo.ceNm}
                </Descriptions.Item>
              }
            </Descriptions>
          </div>
          <div className="my_info_pw_c">
            <Form
              form={form} 
              layout="vertical" 
              name="pwForm"
              onFinish={this.onModpw}
            >
              <Form.Item
                label="현재 비밀번호"
                name="cePw"
                rules={[{ required: true, message: '현재 비밀번호를 입력하세요.' }]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                label="변경 비밀번호"
                name="cePwNew"
                rules={[{ required: true, message: '변경 비밀번호를 입력하세요.' }]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                label="변경 비밀번호 확인"
                name="cePwNew1"
                rules={[{ required: true, message: '변경 비밀번호를 입력하세요.' }]}
              >
                <Input.Password />
              </Form.Item>
              <div className="my_info_pw_edit">
                <Form.Item>
                  <Button type="primary" htmlType="submit">비밀번호 변경</Button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <Button onClick={onCancel}>닫기</Button>
                </Form.Item>
              </div>
            </Form>
          </div>
        </Modal>
      );
    };
    return sessionLoginInfo !== null && (
      <ModalForm visible={modalOpen} />
    );
  }

}

export default MyInfoModal;